import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import noop from 'lodash/noop';

import SpinnerTwo from '@ad-scripts/presentation/components/common/spinner_two';

import EmbedModal, { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import TransferContext from 'src/presentation/contexts/TransferContext';

type TransferProgressProps = {
  filename?: string;
  isReplacing?: boolean;
};

const TransferSpinner: FC<TransferProgressProps> = ({ filename, isReplacing }) => {
  const onClose = () => noop;
  const { status } = useContext(TransferContext);
  return (
    <StyledEmbedModal
      showCloseButton={false}
      title=""
      content={
        <>
          <SpinnerContainer>
            <StyledSpinner />
          </SpinnerContainer>
          <TransferSpinnerTextWrapper>
            {status ? status : isReplacing ? 'Replacing content of' : 'Uploading'}
            <br />
            {filename}
          </TransferSpinnerTextWrapper>
        </>
      }
      onCancel={onClose}
      modalSize={ModalSize.LARGE}
    />
  );
};

const StyledEmbedModal = styled(EmbedModal)`
  .Modal-backdrop {
    background-color: transparent;
  }

  .modalCard-backdrop {
    z-index: 10;
  }

  .modalCard-content {
    padding: 18px 45px;
  }

  .modalCard-content {
    border: 1px solid ${p => p.theme.colors.gray300};
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04), 0px 0px 10px rgba(0, 0, 0, 0.06), 0px 0px 80px rgba(0, 0, 0, 0.06);
  }
`;

const TransferSpinnerTextWrapper = styled.div`
  line-height: 20px;
  margin-top: 20px;
  min-width: 192px;
  text-align: center;
`;

const StyledSpinner = styled(SpinnerTwo).attrs(p => ({ color: p.theme.colors.green400, size: 48, stroke: 3 }))``;

const SpinnerContainer = styled.span`
  align-items: center;
  display: flex;
  flex: 1 1 300px;
  justify-content: center;
  width: 100%;
`;

export default TransferSpinner;
